
import { ReactNode } from 'react';

interface ProtectedRouteProps {
  children: ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  // Since we're not using backend authentication, we'll just render the children directly
  // A real auth system would check the user's authentication status here
  return <>{children}</>;
};
